export var generateHeaders = function (accessToken) {
    return {
        Authorization: "Bearer " + accessToken,
    };
};
//# sourceMappingURL=generateHeaders.js.map